import { NgModule, Optional, SkipSelf } from '@angular/core';

import { SettingsService } from './settings/settings.service';
import { ThemesService } from './themes/themes.service';
import { TranslatorService } from './translator/translator.service';
import { MenuService } from './menu/menu.service';

import { throwIfAlreadyLoaded } from './module-import-guard';
import { LayoutComponent } from './layout/layout.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { UserblockComponent } from './layout/sidebar/userblock/userblock.component';
import { HeaderComponent } from './layout/header/header.component';
import { NavsearchComponent } from './layout/header/navsearch/navsearch.component';
import { OffsidebarComponent } from './layout/offsidebar/offsidebar.component';
import { FooterComponent } from './layout/footer/footer.component';
import { UserblockService } from './layout/sidebar/userblock/userblock.service';
import { SharedModule } from '../shared/shared.module';
import { AuthGuard } from './guards/auth.guard';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './guards/auth.interceptor';
import { menu } from './menu/menu';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
    imports: [
        SharedModule,
        FontAwesomeModule
    ],
    providers: [
        SettingsService,
        ThemesService,
        TranslatorService,
        MenuService,
        UserblockService,
        AuthGuard,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        }
    ],
    declarations: [
        LayoutComponent,
        SidebarComponent,
        UserblockComponent,
        HeaderComponent,
        NavsearchComponent,
        OffsidebarComponent,
        FooterComponent
    ],
    exports: [
        LayoutComponent,
        SidebarComponent,
        UserblockComponent,
        HeaderComponent,
        NavsearchComponent,
        OffsidebarComponent,
        FooterComponent
    ]
})
export class CoreModule {
    constructor( @Optional() @SkipSelf() parentModule: CoreModule, menuService: MenuService) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
        menuService.init(menu);

    }
}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/core/core.module.ts